import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

const titleWithDescriptionStyle = css`
  font-weight: 600;
  line-height: 24px;
`;

const alertConfig: ConfigProviderProps['alert'] = {
  errorIcon: <i className="fb-icon--issue-filled" />,
  warningIcon: <i className="fb-icon--warning-filled" />,
  successIcon: <i className="fb-icon--circle-check-filled" />,
  styles: {
    icon: {
      marginInlineEnd: 12,
    },
  },
  classNames: ({ props }) => ({
    title: props.description ? titleWithDescriptionStyle : undefined,
  }),
};

export default alertConfig;
